import {UploadImage} from 'components/UI/Image';
import {DateTime} from 'components/UI/DateTime';
import {Link} from 'react-router-dom';

export default function(props) {
  return (
    <div className='item-comment-header business-message'>
      <div className='logo'>
        <Link to={`/business/${props.business.id}`}>
          <UploadImage transform="crop" width={48} height={48} type='BUSINESS' image={props.business.logo}/>
        </Link>
      </div>
      <div className='content-justify poster-info'>
        <p className='item-comment-business-name'><Link className='link-to' to={`/business/${props.business.id}`}>{props.business.name}</Link></p>
        <p className='item-comment-business-desc'><DateTime dateTime={props.message.createdAt}/></p>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./components/conversations/partials/BusinessMessageHeading.jsx